export const themeData5 = {
  showRating: true,
  ratingBg: '#FF6640',
  showBtn: true,
  btnTextColor: '#000',
  btnHoverTextColor: '#000',
  btnHoverBgColor: '#fff',
  btnBgColor: '#fff',
  borderRadius: '0',
  borderColor: '#000000',
  addedCartText: 'Added to cart',
  addCartText: 'Add to cart',
  showSelectBox: true,
  selectBorderColor: '#8B8B8B',
  selectColor: '#8B8B8B',
  soldOutText: 'Sold Out',
  soldOutTextColor: '#fff',
  soldOutBgColor: '#FFFFFF',
  soldOutPosition: 'top-right',
  titlePorition: 'flex-start',
  bgColor: '#FFFFFF',
  TitleColor: '#010101',
  bgImgColor: '',
  productTitleColor: '#030303',
  priceColor: '#FF6640',
  originalPriceColor: '#B1B1B1',
  heightDesktopImage: '236',
  widthDesktopImage: '236',
  heightMobileImage: '236',
  widthMobileImage: '236'
};
